import { openDB, IDBPDatabase } from 'idb'

let dbPromise: Promise<IDBPDatabase<any>> | null = null;

export const getDB = () => {
  if (typeof window === 'undefined') return null;
  if (!dbPromise) {
    dbPromise = openDB('offline-queue', 1, {
      upgrade(db) {
        db.createObjectStore('requests', { autoIncrement: true })
      },
    })
  }
  return dbPromise;
}

export async function saveRequest(requestData: any) {
  const db = await getDB()
  if (!db) return
  await db.put('requests', requestData)
}

export async function getAllRequests() {
  const db = await getDB()
  if (!db) return []
  return db.getAll('requests')
}

export async function getAllRequestsWithKeys() {
  const db = await getDB()
  if (!db) return []
  const keys = await db.getAllKeys('requests')
  const values = await db.getAll('requests')
  return keys.map((key, i) => ({ id: key as number, data: values[i] }))
}

export async function deleteRequest(id: number) {
  const db = await getDB()
  if (!db) return
  return db.delete('requests', id)
}

export async function clearRequests() {
  const db = await getDB()
  if (!db) return
  return db.clear('requests')
}